import React from 'react';
import { TimerIcon } from 'lucide-react';
import { useCountdown } from '../../hooks/useCountdown';
type CountdownProps = {
  label?: string;
};
export function Countdown({
  label = 'Promotional price ends in:'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Minutes'
  }, {
    value: seconds,
    label: 'Seconds'
  }];
  return <div className="w-full max-w-xl rounded-2xl border-2 border-danger/70 bg-[#2A0F1A] px-4 py-5 text-white" role="timer" aria-live="off" data-id="element-376" data-mp="1oflt1847k9s7">
      <p className="flex items-center justify-center gap-2 text-center font-display text-sm font-bold uppercase tracking-wide text-[#FF9EA1]" data-id="element-377" data-mp="1xfs30k0p6rmm">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-378" data-mp="1tdncvv9gkd4q" />
        {label}
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-379" data-mp="38u5mlcof4kwu">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-380" data-mp="34stun0i2nnlh" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-381" data-mp="34vy2c7uqx1gw">
              <span className="min-w-[72px] rounded-xl bg-danger px-2 py-2 text-center font-display text-4xl font-black tabular-nums leading-none sm:min-w-[88px] sm:text-5xl" data-id="element-382" data-mp="2c6vnayscwba7">
                {u.value}
              </span>
              <span className="mt-2 text-[11px] font-semibold uppercase tracking-wider text-white/70" data-id="element-383" data-mp="2l68xxus7v5wi">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className="pt-2 font-display text-3xl font-black text-danger sm:text-4xl" data-id="element-384" data-mp="1ti75ilp66m2n">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}